import { keyframes as i } from "@emotion/react";
const e = i({ from: { display: "block" } }), n = i({
  from: { boxSizing: "border-box" }
}), r = {
  border: "none",
  outline: "none",
  p: 0,
  fontSize: "md",
  transition: "all",
  animationName: n,
  animationDuration: "1ms",
  ":focus-visible": {
    outline: 0
  },
  ":-webkit-autofill": {
    animationName: e
  }
}, u = {
  filled: {
    ...r
  },
  ghost: {
    ...r
  }
}, t = {
  position: "relative",
  display: "inline-flex",
  alignItems: "flex-start",
  columnGap: 2,
  color: "secondaryText",
  transition: "all",
  width: 253,
  "&:hover": {
    color: "primary"
  }
}, l = {
  filled: {
    ...t,
    bg: "secondary"
  },
  ghost: {
    ...t,
    borderBottom: (o) => o.border(0.25, "disabledText"),
    borderRadius: 0,
    px: 1,
    "&:hover": {
      color: "primary",
      borderBottomColor: "primary"
    }
  }
}, a = {
  md: {
    borderRadius: "sm",
    px: 2
  },
  lg: {
    borderRadius: "md",
    px: 3
  },
  xl: {
    borderRadius: "md",
    px: 3
  },
  xxl: {
    borderRadius: "md",
    px: 3
  }
}, s = {
  filled: {
    error: {
      "&": (o) => ({ ...o.outline({ color: "error" }) })
    },
    focused: {
      color: "primary"
    }
  },
  ghost: {
    error: {
      "&, &:hover": {
        borderBottomColor: "error"
      }
    },
    focused: {
      color: "primary",
      borderBottomColor: "primary"
    }
  }
}, p = {
  md: {
    height: 9
  },
  lg: {
    height: 12
  },
  xl: {
    height: 14
  },
  xxl: {
    height: 16
  }
}, m = {
  md: {
    top: 2
  },
  lg: {
    top: (o) => o.spacing(3.5)
  },
  xl: {
    top: (o) => o.spacing(4.5)
  },
  xxl: {
    top: (o) => o.spacing(5.5)
  }
}, d = {
  md: {
    mt: 0
  },
  lg: {
    mt: (o) => o.spacing(1.5)
  },
  xl: {
    mt: (o) => o.spacing(2.5)
  },
  xxl: {
    mt: (o) => o.spacing(3.5)
  }
}, x = {
  inputWrapper: l,
  inputWrapperSizes: a,
  inputWrapperVariantStateStyles: s,
  inputSizes: p,
  inputPlaceholderSizes: m,
  inputAdornmentSizes: d
};
export {
  u as input,
  e as inputAutofillAnimation,
  n as inputAutofillCancelAnimation,
  x as inputsTheme
};
